import React, { FC } from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { palette } from '../../../theme';

interface CEONavbarLinkProps {
  /** The title of the navigation link */
  title: string;
  /** Flag to determine if a link is active */
  isActive: boolean;
  /** The icon to show inside the link */
  icon: any;
  /** When true, only the icon is shown (collapsed sidebar) */
  collapsed?: boolean;
  /** A function to be called when the link is clicked */
  onClick?: () => any;
}

const COENavbarLink: FC<CEONavbarLinkProps> = (props) => {
  return (
    <ListItemButton
      sx={{
        height: 40,
        overflow: 'hidden',
        mx: 1,
        borderRadius: '8px',
        backgroundColor: props.isActive ? palette.primary.light : 'transparent',
        '&:hover': { backgroundColor: 'rgba(209,225,255,0.4)' },
        ...(props.collapsed && {
          justifyContent: 'center',
          px: 0,
          '& .MuiListItemText-root': { display: 'none' },
          '& .MuiListItemIcon-root': { minWidth: 'unset', mr: 0, justifyContent: 'center' },
        }),
      }}
      onClick={props.onClick}
    >
      <ListItemIcon sx={{ minWidth: 32, mr: 0.5 }}>{props.icon}</ListItemIcon>
      <ListItemText
        primary={props.title}
        primaryTypographyProps={{
          sx: {
            color: props.isActive ? palette.primary.main : palette.text.primary,
            fontSize: 12,
            fontWeight: props.isActive ? 600 : 400,
          },
        }}
      />
    </ListItemButton>
  );
};

export default COENavbarLink;
